/*
 * PKI.Gost — российская криптография, которой нет в WebCrypto: хеши
 * ГОСТ Р 34.11-2012 «Стрибог» (256/512) и ГОСТ Р 34.11-94, и ПРОВЕРКА подписи
 * ГОСТ Р 34.10-2012 / 34.10-2001.
 *
 * Зачем. Почти каждая квалифицированная подпись в России — это ГОСТ: файлы .sig
 * от Росреестра, налоговой, судов и контрагентов. WebCrypto ГОСТа не знает,
 * поэтому до сих пор единственный способ проверить такую подпись — поставить
 * КриптоПро или отдать файл чужому серверу. Проверка открытым ключом — чистая
 * арифметика, ей не нужен сертифицированный криптопровайдер: подписывать мы
 * ничего не умеем и не должны, мы только проверяем.
 *
 * Откуда числа. Таблицы Стрибога (π, τ, матрица A, константы C) — RFC 6986;
 * параметры кривых — RFC 4357 (наборы КриптоПро, взяты из DER-вложения самого
 * RFC) и RFC 7836 (наборы ТК 26). Таблицы вставлены генератором из текста RFC,
 * а не переписаны руками; каждая кривая при сборке проверена (базовая точка на
 * кривой, q·P = ∞).
 *
 * Порядок байтов — единственное место, где тут легко ошибиться, и ошибиться
 * молча: подпись просто «не сойдётся».
 *   • хеш: на выходе — байты «в памяти» (как печатает openssl dgst); в число для
 *     подписи они превращаются как LITTLE-endian (так делают КриптоПро и
 *     gost-engine; в стандарте вектор записан наоборот);
 *   • открытый ключ: OCTET STRING из x‖y, каждая координата little-endian
 *     (RFC 4491 §2.3.2, RFC 9215 §4.3);
 *   • подпись: s‖r, каждая половина BIG-endian (RFC 4491 §2.2.2, RFC 9215 §3).
 *
 * Проверено: векторы RFC 6986 и RFC 5831 и корпус подписей, сделанный
 * OpenSSL + gost-engine (tests/fixtures/signatures/gost, все наборы кривых).
 *
 * ES2019 без BigInt-литералов (esbuild --target=es2018 их не пропускает) —
 * поэтому BigInt(…) везде вместо 0n.
 */
(function (root) {
    'use strict';

    var PI_HEX = 'fceedd11cf6e3116fbc4fada23c5044de977f0db932e99ba1736f1bb14cd5fc1f918655ae25cef21811c3c428b018e4f058402aee36a8fa0060bed987fd4d31feb342c51eac848abf22a68a2fd3aceccb5700e56080c7612bf7213479cb75d8715a19629107b9ac7f391786f9d9eb2b13275193dff358a7e6d54c680c3bd0d57dff524a93ea843c9d779d6f67c22b903e00fecde7a94b0bcdce828504e330a4aa79760731e0062441ab83882649f2641ad454692275e552f8ca3a57d69d5953b0758b34086ac1df730376be488d9e789e11b83494c3ff8fe8d53aa90cad88561207167a42d2b095bcb9b25d0bee56c5259a674d2e6f4b4c0d166afc2394b63b6';
    var A_HEX = '8e20faa72ba0b47047107ddd9b505a38ad08b0e0c3282d1cd8045870ef14980e6c022c38f90a4c073601161cf205268d1b8e0b0e798c13c883478b07b2468764a011d380818e8f405086e740ce47c9202843fd2067adea1014aff010bdd875080ad97808d06cb40405e23c0468365a028c711e02341b2d0146b60f011a83988e90dab52a387ae76f486dd4151c3dfdb924b86a840e90f0d2125c354207487869092e94218d243cba8a174a9ec8121e5d4585254f64090fa0accc9ca9328a89509d4df05d5f661451c0a878a0a1330aa660543c50de970553302a1e286fc58ca718150f14b9ec46dd0c84890ad27623e00642ca05693b9f700321658cba93c13886275df09ce8aaa8439da0784e745554afc0503c273aa42ad960281e9d1d5215e230140fc080298471180a8960409a42b60c05ca30204d215b068c651810a89e456c34887a3805b9ac361a443d1c8cd2561b0d22900e46692b838811480723ba9bcf4486248d9f5dc3e9224312c8c1a0effa11af0964ee50f97d86d98a327728e4fa2054a80b329c727d102a548b194e39b008152acb82279258048415eb419d492c024284fbaec0aa16012142f35760550b8e9e21f7a530a48b474f9ef5dc1870a6a56e2440598e3853dc371220a2471ca76e95091051ad0edd37c48a08a6d807e095624504536c8d70c431ac02a736c83862965601dd1b641c314b2b8ee083';
    var C_HEX = [
        'b1085bda1ecadae9ebcb2f81c0657c1f2f6a76432e45d016714eb88d7585c4fc4b7ce09192676901a2422a08a460d31505767436cc744d23dd806559f2a64507',
        '6fa3b58aa99d2f1a4fe39d460f70b5d7f3feea720a232b9861d55e0f16b501319ab5176b12d699585cb561c2db0aa7ca55dda21bd7cbcd56e679047021b19bb7',
        'f574dcac2bce2fc70a39fc286a3d843506f15e5f529c1f8bf2ea7514b1297b7bd3e20fe490359eb1c1c93a376062db09c2b6f443867adb31991e96f50aba0ab2',
        'ef1fdfb3e81566d2f948e1a05d71e4dd488e857e335c3c7d9d721cad685e353fa9d72c82ed03d675d8b71333935203be3453eaa193e837f1220cbebc84e3d12e',
        '4bea6bacad4747999a3f410c6ca923637f151c1f1686104a359e35d7800fffbdbfcd1747253af5a3dfff00b723271a167a56a27ea9ea63f5601758fd7c6cfe57',
        'ae4faeae1d3ad3d96fa4c33b7a3039c02d66c4f95142a46c187f9ab49af08ec6cffaa6b71c9ab7b40af21f66c2bec6b6bf71c57236904f35fa68407a46647d6e',
        'f4c70e16eeaac5ec51ac86febf240954399ec6c7e6bf87c9d3473e33197a93c90992abc52d822c3706476983284a05043517454ca23c4af38886564d3a14d493',
        '9b1f5b424d93c9a703e7aa020c6e41414eb7f8719c36de1e89b4443b4ddbc49af4892bcb929b069069d18d2bd1a5c42f36acc2355951a8d9a47f0dd4bf02e71e',
        '378f5a541631229b944c9ad8ec165fde3a7d3a1b258942243cd955b7e00d0984800a440bdbb2ceb17b2b8a9aa6079c540e38dc92cb1f2a607261445183235adb',
        'abbedea680056f52382ae548b2e4f3f38941e71cff8a78db1fffe18a1b3361039fe76702af69334b7a1e6c303b7652f43698fad1153bb6c374b4c7fb98459ced',
        '7bcd9ed0efc889fb3002c6cd635afe94d8fa6bbbebab076120018021148466798a1d71efea48b9caefbacd1d7d476e98dea2594ac06fd85d6bcaa4cd81f32d1b',
        '378ee767f11631bad21380b00449b17acda43c32bcdf1d77f82012d430219f9b5d80ef9d1891cc86e71da4aa88e12852faf417d5d9b21b9948bc924af11bd720'
    ];
    var SBOX_HEX = {
        test: '4e5764d1ab8dcbbf941a7a4d2cd11010d6a057358d38f2f70f49d15aea2f8d9462ee4309b3f4a6a218c698e3c17ce57e706b0966f7023c8b5595bf2839b32ecc',
        cryptopro: 'a57477d14ffa66e354c7424a60ecb41982909d751d4fc90b3b122f547908a0afd13e1a38c7b181c6e65605870325ebfe9c6df86d2eabde20ba893c92f8d353bc'
    };
    var CURVE_HEX = {
        '1.2.643.2.2.35.0': { // id-GostR3410-2001-TestParamSet
            p: '8000000000000000000000000000000000000000000000000000000000000431',
            a: '7',
            b: '5fbff498aa938ce739b8e022fbafef40563f6e6a3472fc2a514c0ce9dae23b7e',
            q: '8000000000000000000000000000000150fe8a1892976154c59cfc193accf5b3',
            x: '2',
            y: '8e2a8a0e65147d4bd6316030e16d19c85c97f0a9ca267122b96abbcea7e8fc8' },
        '1.2.643.2.2.35.1': { // id-GostR3410-2001-CryptoPro-A-ParamSet
            p: 'fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffd97',
            a: 'fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffd94',
            b: 'a6',
            q: 'ffffffffffffffffffffffffffffffff6c611070995ad10045841b09b761b893',
            x: '1',
            y: '8d91e471e0989cda27df505a453f2b7635294f2ddf23e3b122acc99c9e9f1e14' },
        '1.2.643.2.2.35.2': { // id-GostR3410-2001-CryptoPro-B-ParamSet
            p: '8000000000000000000000000000000000000000000000000000000000000c99',
            a: '8000000000000000000000000000000000000000000000000000000000000c96',
            b: '3e1af419a269a5f866a7d3c25c3df80ae979259373ff2b182f49d4ce7e1bbc8b',
            q: '800000000000000000000000000000015f700cfff1a624e5e497161bcc8a198f',
            x: '1',
            y: '3fa8124359f96680b83d1c3eb2c070e5c545c9858d03ecfb744bf8d717717efc' },
        '1.2.643.2.2.35.3': { // id-GostR3410-2001-CryptoPro-C-ParamSet
            p: '9b9f605f5a858107ab1ec85e6b41c8aacf846e86789051d37998f7b9022d759b',
            a: '9b9f605f5a858107ab1ec85e6b41c8aacf846e86789051d37998f7b9022d7598',
            b: '805a',
            q: '9b9f605f5a858107ab1ec85e6b41c8aa582ca3511eddfb74f02f3a6598980bb9',
            x: '0',
            y: '41ece55743711a8c3cbf3783cd08c0ee4d4dc440d4641a8f366e550dfdb3bb67' },
        '1.2.643.2.2.36.0': { // id-GostR3410-2001-CryptoPro-XchA-ParamSet
            p: 'fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffd97',
            a: 'fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffd94',
            b: 'a6',
            q: 'ffffffffffffffffffffffffffffffff6c611070995ad10045841b09b761b893',
            x: '1',
            y: '8d91e471e0989cda27df505a453f2b7635294f2ddf23e3b122acc99c9e9f1e14' },
        '1.2.643.2.2.36.1': { // id-GostR3410-2001-CryptoPro-XchB-ParamSet
            p: '9b9f605f5a858107ab1ec85e6b41c8aacf846e86789051d37998f7b9022d759b',
            a: '9b9f605f5a858107ab1ec85e6b41c8aacf846e86789051d37998f7b9022d7598',
            b: '805a',
            q: '9b9f605f5a858107ab1ec85e6b41c8aa582ca3511eddfb74f02f3a6598980bb9',
            x: '0',
            y: '41ece55743711a8c3cbf3783cd08c0ee4d4dc440d4641a8f366e550dfdb3bb67' },
        '1.2.643.7.1.2.1.2.1': { // id-tc26-gost-3410-12-512-paramSetA
            p: 'fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffdc7',
            a: 'fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffdc4',
            b: 'e8c2505dedfc86ddc1bd0b2b6667f1da34b82574761cb0e879bd081cfd0b6265ee3cb090f30d27614cb4574010da90dd862ef9d4ebee4761503190785a71c760',
            q: 'ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff27e69532f48d89116ff22b8d4e0560609b4b38abfad2b85dcacdb1411f10b275',
            x: '3',
            y: '7503cfe87a836ae3a61b8816e25450e6ce5e1c93acf1abc1778064fdcbefa921df1626be4fd036e93d75e6a50e3a41e98028fe5fc235f5b889a589cb5215f2a4' },
        '1.2.643.7.1.2.1.2.2': { // id-tc26-gost-3410-12-512-paramSetB
            p: '8000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000006f',
            a: '8000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000006c',
            b: '687d1b459dc841457e3e06cf6f5e2517b97c7d614af138bcbf85dc806c4b289f3e965d2db1416d217f8b276fad1ab69c50f78bee1fa3106efb8ccbc7c5140116',
            q: '800000000000000000000000000000000000000000000000000000000000000149a1ec142565a545acfdb77bd9d40cfa8b996712101bea0ec6346c54374f25bd',
            x: '2',
            y: '1a8f7eda389b094c2c071e3647a8940f3c123b697578c213be6dd9e6c8ec7335dcb228fd1edf4a39152cbcaaf8c0398828041055f94ceeec7e21340780fe41bd' },
        '1.2.643.7.1.2.1.1.1': { // id-tc26-gost-3410-12-256-paramSetA
            p: 'fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffd97',
            a: 'c2173f1513981673af4892c23035a27ce25e2013bf95aa33b22c656f277e7335',
            b: '295f9bae7428ed9ccc20e7c359a9d41a22fccd9108e17bf7ba9337a6f8ae9513',
            q: '400000000000000000000000000000000fd8cddfc87b6635c115af556c360c67',
            x: '91e38443a5e82c0d880923425712b2bb658b9196932e02c78b2582fe742daa28',
            y: '32879423ab1a0375895786c4bb46e9565fde0b5344766740af268adb32322e5c' },
        '1.2.643.7.1.2.1.2.3': { // id-tc26-gost-3410-12-512-paramSetC
            p: 'fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffdc7',
            a: 'dc9203e514a721875485a529d2c722fb187bc8980eb866644de41c68e143064546e861c0e2c9edd92ade71f46fcf50ff2ad97f951fda9f2a2eb6546f39689bd3',
            b: 'b4c4ee28cebc6c2c8ac12952cf37f16ac7efb6a9f69f4b57ffda2e4f0de5ade038cbc2fff719d2c18de0284b8bfef3b52b8cc7a5f5bf0a3c8d2319a5312557e1',
            q: '3fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffc98cdba46506ab004c33a9ff5147502cc8eda9e7a769a12694623cef47f023ed',
            x: 'e2e31edfc23de7bdebe241ce593ef5de2295b7a9cbaef021d385f7074cea043aa27272a7ae602bf2a7b9033db9ed3610c6fb85487eae97aac5bc7928c1950148',
            y: 'f5ce40d95b5eb899abbccff5911cb8577939804d6527378b8c108c3d2090ff9be18e2d33e3021ed2ef32d85822423b6304f726aa854bae07d0396e9a9addc40f' }
    };
    var CURVE_ALIAS = {
        '1.2.643.2.2.36.0': '1.2.643.2.2.35.1',
        '1.2.643.2.2.36.1': '1.2.643.2.2.35.3',
        '1.2.643.7.1.2.1.1.2': '1.2.643.2.2.35.1',
        '1.2.643.7.1.2.1.1.3': '1.2.643.2.2.35.2',
        '1.2.643.7.1.2.1.1.4': '1.2.643.2.2.35.3'
    };

    function hexToBytes(hex) {
        var out = new Uint8Array(hex.length >> 1);
        for (var i = 0; i < out.length; i++) out[i] = parseInt(hex.substr(i * 2, 2), 16);
        return out;
    }
    function u8(x) {
        if (x instanceof Uint8Array) return x;
        if (x instanceof ArrayBuffer) return new Uint8Array(x);
        if (ArrayBuffer.isView(x)) return new Uint8Array(x.buffer, x.byteOffset, x.byteLength);
        if (typeof x === 'string') return new TextEncoder().encode(x);
        return new Uint8Array(x || 0);
    }
    function bytesToHex(b) {
        var s = '';
        for (var i = 0; i < b.length; i++) s += (b[i] < 16 ? '0' : '') + b[i].toString(16);
        return s;
    }

    /* ══════════════ ГОСТ Р 34.11-2012 «Стрибог» ══════════════ */

    var PI = hexToBytes(PI_HEX);

    /* LPS одной таблицей: выходное 64-битное слово w = XOR по k=0..7 от
       T[k][x[8k+w]], где T[k][v] = l(Pi[v], поставленного в байт k слова).
       Это S, P (транспонирование 8×8 байт) и L, сведённые к 64 поискам. */
    var TLO = new Int32Array(2048), THI = new Int32Array(2048);
    (function () {
        var rowLo = new Int32Array(64), rowHi = new Int32Array(64);
        for (var r = 0; r < 64; r++) {
            rowHi[r] = parseInt(A_HEX.substr(r * 16, 8), 16) | 0;
            rowLo[r] = parseInt(A_HEX.substr(r * 16 + 8, 8), 16) | 0;
        }
        for (var k = 0; k < 8; k++) {
            for (var v = 0; v < 256; v++) {
                var s = PI[v], lo = 0, hi = 0;
                for (var j = 0; j < 8; j++) {
                    if (s & (1 << j)) {
                        var row = 63 - (8 * k + j);
                        lo ^= rowLo[row];
                        hi ^= rowHi[row];
                    }
                }
                TLO[(k << 8) | v] = lo;
                THI[(k << 8) | v] = hi;
            }
        }
    })();

    /* Константы C[1..12]: в RFC записаны старшим байтом вперёд, в памяти —
       наоборот. Слово i (32 бита) = байты 4i..4i+3, младший первым. */
    var C = C_HEX.map(function (hex) {
        var be = hexToBytes(hex), le = new Uint8Array(64);
        for (var i = 0; i < 64; i++) le[i] = be[63 - i];
        return bytesToWords(le, 0, new Int32Array(16));
    });

    function bytesToWords(b, off, out) {
        for (var i = 0; i < 16; i++) {
            var o = off + i * 4;
            out[i] = b[o] | (b[o + 1] << 8) | (b[o + 2] << 16) | (b[o + 3] << 24);
        }
        return out;
    }

    function lps(x, out) {
        for (var w = 0; w < 8; w++) {
            var lo = 0, hi = 0;
            for (var k = 0; k < 8; k++) {
                var m = 8 * k + w;
                var idx = (k << 8) | ((x[m >> 2] >>> ((m & 3) << 3)) & 0xff);
                lo ^= TLO[idx];
                hi ^= THI[idx];
            }
            out[w << 1] = lo;
            out[(w << 1) | 1] = hi;
        }
    }

    // g_N(h, m) = E(LPS(h xor N), m) xor h xor m — результат пишется в h.
    var gK = new Int32Array(16), gS = new Int32Array(16), gT = new Int32Array(16);
    function g(N, h, m) {
        var i, r;
        for (i = 0; i < 16; i++) gT[i] = h[i] ^ N[i];
        lps(gT, gK);
        for (i = 0; i < 16; i++) gS[i] = m[i];
        for (r = 0; r < 12; r++) {
            for (i = 0; i < 16; i++) gT[i] = gS[i] ^ gK[i];
            lps(gT, gS);
            var c = C[r];
            for (i = 0; i < 16; i++) gT[i] = gK[i] ^ c[i];
            lps(gT, gK);
        }
        for (i = 0; i < 16; i++) h[i] = gS[i] ^ gK[i] ^ h[i] ^ m[i];
    }

    function add512(a, b) {
        var carry = 0;
        for (var i = 0; i < 16; i++) {
            var s = (a[i] >>> 0) + (b[i] >>> 0) + carry;
            a[i] = s | 0;
            carry = s >= 4294967296 ? 1 : 0;
        }
    }
    function add512Small(a, n) {
        var carry = n;
        for (var i = 0; i < 16 && carry; i++) {
            var s = (a[i] >>> 0) + carry;
            a[i] = s | 0;
            carry = s >= 4294967296 ? 1 : 0;
        }
    }

    var ZERO16 = new Int32Array(16);

    /**
     * Инкрементальный Стрибог: большие файлы идут кусками, не собираясь в один
     * буфер. bits — 256 или 512.
     */
    function createStreebog(bits) {
        if (bits !== 256 && bits !== 512) throw new Error('STREEBOG_BITS');
        var h = new Int32Array(16);
        if (bits === 256) for (var i = 0; i < 16; i++) h[i] = 0x01010101;
        var N = new Int32Array(16), S = new Int32Array(16), m = new Int32Array(16);
        var buf = new Uint8Array(64), bufLen = 0, done = false;

        function block(bytes, off) {
            bytesToWords(bytes, off, m);
            g(N, h, m);
            add512Small(N, 512);
            add512(S, m);
        }
        return {
            update: function (data) {
                if (done) throw new Error('STREEBOG_FINISHED');
                var d = u8(data), off = 0;
                if (bufLen) {
                    var take = Math.min(64 - bufLen, d.length);
                    buf.set(d.subarray(0, take), bufLen);
                    bufLen += take; off = take;
                    if (bufLen === 64) { block(buf, 0); bufLen = 0; }
                }
                while (d.length - off >= 64) { block(d, off); off += 64; }
                if (off < d.length) { buf.set(d.subarray(off), 0); bufLen = d.length - off; }
                return this;
            },
            digest: function () {
                if (done) throw new Error('STREEBOG_FINISHED');
                done = true;
                var last = new Uint8Array(64);
                last.set(buf.subarray(0, bufLen), 0);
                last[bufLen] = 0x01;
                bytesToWords(last, 0, m);
                g(N, h, m);
                add512Small(N, bufLen * 8);
                add512(S, m);
                g(ZERO16, h, N);
                g(ZERO16, h, S);
                var out = new Uint8Array(64);
                for (var j = 0; j < 64; j++) out[j] = (h[j >> 2] >>> ((j & 3) << 3)) & 0xff;
                return bits === 512 ? out : out.slice(32);
            }
        };
    }
    function streebog256(data) { return createStreebog(256).update(data).digest(); }
    function streebog512(data) { return createStreebog(512).update(data).digest(); }

    /* ══════════════ ГОСТ Р 34.11-94 (для подписей ГОСТ Р 34.10-2001) ══════════════
       Подписи 2001 года больше не выпускают (запрещены с 2019), но документы,
       подписанные тогда, лежат в архивах и приходят на проверку до сих пор. */

    /* Узел замены: 16 строк по 4 байта, в строке r — полубайты pi1..pi8
       (pi1 — старший полубайт первого байта). pi1 применяется к младшему
       полубайту 32-битного слова. Сворачиваем в 4 таблицы по байту. */
    function expandSbox(hex) {
        var raw = hexToBytes(hex), k = [];
        for (var n = 0; n < 8; n++) k.push(new Uint8Array(16));
        for (var r = 0; r < 16; r++) {
            for (var b = 0; b < 4; b++) {
                var v = raw[r * 4 + b];
                k[b * 2][r] = v >> 4;
                k[b * 2 + 1][r] = v & 15;
            }
        }
        var t = [new Uint32Array(256), new Uint32Array(256), new Uint32Array(256), new Uint32Array(256)];
        for (var i = 0; i < 256; i++) {
            t[0][i] = (k[1][i >> 4] << 4) | k[0][i & 15];
            t[1][i] = ((k[3][i >> 4] << 4) | k[2][i & 15]) << 8;
            t[2][i] = ((k[5][i >> 4] << 4) | k[4][i & 15]) << 16;
            t[3][i] = (((k[7][i >> 4] << 4) | k[6][i & 15]) << 24) >>> 0;
        }
        return t;
    }
    var SBOXES = {};
    function sbox(name) {
        if (!SBOXES[name]) {
            if (!SBOX_HEX[name]) throw new Error('GOST94_SBOX:' + name);
            SBOXES[name] = expandSbox(SBOX_HEX[name]);
        }
        return SBOXES[name];
    }

    function magmaF(t, x) {
        var y = (t[0][x & 255] | t[1][(x >>> 8) & 255] | t[2][(x >>> 16) & 255] | t[3][x >>> 24]) >>> 0;
        return ((y << 11) | (y >>> 21)) >>> 0;
    }
    /* ECB-шифрование одного 64-битного блока (8 байт) ключом из 32 байт. */
    function magmaEncrypt(t, key, inp, inOff, out, outOff) {
        var k = new Uint32Array(8), i;
        for (i = 0; i < 8; i++) {
            k[i] = (key[i * 4] | (key[i * 4 + 1] << 8) | (key[i * 4 + 2] << 16) | (key[i * 4 + 3] << 24)) >>> 0;
        }
        var n1 = (inp[inOff] | (inp[inOff + 1] << 8) | (inp[inOff + 2] << 16) | (inp[inOff + 3] << 24)) >>> 0;
        var n2 = (inp[inOff + 4] | (inp[inOff + 5] << 8) | (inp[inOff + 6] << 16) | (inp[inOff + 7] << 24)) >>> 0;
        for (var round = 0; round < 32; round++) {
            var ki = round < 24 ? k[round & 7] : k[7 - (round & 7)];
            if ((round & 1) === 0) n2 = (n2 ^ magmaF(t, (n1 + ki) >>> 0)) >>> 0;
            else n1 = (n1 ^ magmaF(t, (n2 + ki) >>> 0)) >>> 0;
        }
        out[outOff] = n2 & 255; out[outOff + 1] = (n2 >>> 8) & 255;
        out[outOff + 2] = (n2 >>> 16) & 255; out[outOff + 3] = n2 >>> 24;
        out[outOff + 4] = n1 & 255; out[outOff + 5] = (n1 >>> 8) & 255;
        out[outOff + 6] = (n1 >>> 16) & 255; out[outOff + 7] = n1 >>> 24;
    }

    // A(X) = (x1 ⊕ x2) ‖ x4 ‖ x3 ‖ x2 — в памяти сдвиг на 8 байт вниз.
    function transformA(w, k) {
        var buf = w.slice(0, 8), i;
        for (i = 0; i < 24; i++) k[i] = w[i + 8];
        for (i = 0; i < 8; i++) k[i + 24] = buf[i] ^ k[i];
    }
    // P: out[i + 4j] = in[8i + j].
    function transformP(w, k) {
        for (var i = 0; i < 4; i++) for (var j = 0; j < 8; j++) k[i + 4 * j] = w[8 * i + j];
    }
    // ψ: сдвиг на 16 бит; наверх — η1⊕η2⊕η3⊕η4⊕η13⊕η16.
    function psi(d) {
        var lo = d[0] ^ d[2] ^ d[4] ^ d[6] ^ d[24] ^ d[30];
        var hi = d[1] ^ d[3] ^ d[5] ^ d[7] ^ d[25] ^ d[31];
        d.copyWithin(0, 2, 32);
        d[30] = lo; d[31] = hi;
    }
    // Байты, где константа C3 = 1^8: вывод из RFC 5831 §5.1 в порядок «в памяти».
    var C3_ONES = [1, 3, 5, 7, 8, 10, 12, 14, 17, 18, 20, 23, 24, 28, 29, 31];

    function gost94Step(t, H, M) {
        var U = new Uint8Array(32), V = new Uint8Array(32), W = new Uint8Array(32),
            K = new Uint8Array(32), S = new Uint8Array(32), i, n;
        for (i = 0; i < 32; i++) { U[i] = H[i]; V[i] = M[i]; W[i] = U[i] ^ V[i]; }
        transformP(W, K);
        magmaEncrypt(t, K, H, 0, S, 0);
        for (n = 1; n < 4; n++) {
            transformA(U, U);
            if (n === 2) for (i = 0; i < C3_ONES.length; i++) U[C3_ONES[i]] ^= 0xff;
            transformA(V, V);
            transformA(V, V);
            for (i = 0; i < 32; i++) W[i] = U[i] ^ V[i];
            transformP(W, K);
            magmaEncrypt(t, K, H, n * 8, S, n * 8);
        }
        for (i = 0; i < 12; i++) psi(S);
        for (i = 0; i < 32; i++) S[i] ^= M[i];
        psi(S);
        for (i = 0; i < 32; i++) S[i] ^= H[i];
        for (i = 0; i < 61; i++) psi(S);
        H.set(S);
    }
    function add256(sum, block) {
        var carry = 0;
        for (var i = 0; i < 32; i++) {
            var s = sum[i] + block[i] + carry;
            sum[i] = s & 255;
            carry = s >> 8;
        }
    }

    /**
     * Инкрементальный ГОСТ Р 34.11-94. Узел замены — «КриптоПро» по умолчанию
     * (id-GostR3411-94-CryptoProParamSet: им подписано всё, что встречается в
     * жизни); 'test' — набор из примеров стандарта.
     * Как у gost-engine, сообщение кратной 32 байтам длины не получает лишнего
     * нулевого блока (расходится с буквой RFC только на ПУСТОМ сообщении).
     */
    function createGost94(sboxName) {
        var t = sbox(sboxName || 'cryptopro');
        var H = new Uint8Array(32), Sum = new Uint8Array(32);
        var buf = new Uint8Array(32), bufLen = 0, total = 0, done = false;
        function block(bytes, off) {
            var m = bytes.subarray(off, off + 32);
            gost94Step(t, H, m);
            add256(Sum, m);
            total += 32;
        }
        return {
            update: function (data) {
                if (done) throw new Error('GOST94_FINISHED');
                var d = u8(data), off = 0;
                if (bufLen) {
                    var take = Math.min(32 - bufLen, d.length);
                    buf.set(d.subarray(0, take), bufLen);
                    bufLen += take; off = take;
                    if (bufLen === 32) { block(buf, 0); bufLen = 0; }
                }
                while (d.length - off >= 32) { block(d, off); off += 32; }
                if (off < d.length) { buf.set(d.subarray(off), 0); bufLen = d.length - off; }
                return this;
            },
            digest: function () {
                if (done) throw new Error('GOST94_FINISHED');
                done = true;
                if (bufLen) {
                    var last = new Uint8Array(32);
                    last.set(buf.subarray(0, bufLen), 0);
                    gost94Step(t, H, last);
                    add256(Sum, last);
                    total += bufLen;
                }
                // Длина в БИТАХ, 256-битное little-endian число.
                var L = new Uint8Array(32), bitsLo = (total % 536870912) * 8, bitsHi = Math.floor(total / 536870912);
                for (var i = 0; i < 4; i++) L[i] = (bitsLo >>> (8 * i)) & 255;
                for (i = 0; i < 4; i++) L[4 + i] = (bitsHi >>> (8 * i)) & 255;
                gost94Step(t, H, L);
                gost94Step(t, H, Sum);
                return H.slice();
            }
        };
    }
    function gost94(data, sboxName) { return createGost94(sboxName).update(data).digest(); }

    /* ══════════════ OID → хеш ══════════════ */

    var OID = {
        STREEBOG_256: '1.2.643.7.1.1.2.2',
        STREEBOG_512: '1.2.643.7.1.1.2.3',
        GOST94: '1.2.643.2.2.9',
        KEY_2012_256: '1.2.643.7.1.1.1.1',
        KEY_2012_512: '1.2.643.7.1.1.1.2',
        KEY_2001: '1.2.643.2.2.19',
        SIG_2012_256: '1.2.643.7.1.1.3.2',
        SIG_2012_512: '1.2.643.7.1.1.3.3',
        SIG_2001: '1.2.643.2.2.3'
    };
    // Алгоритм хеша по OID; null — не ГОСТ.
    function hashForOid(oid) {
        if (oid === OID.STREEBOG_256) return { name: 'GOST R 34.11-2012 (256)', create: function () { return createStreebog(256); } };
        if (oid === OID.STREEBOG_512) return { name: 'GOST R 34.11-2012 (512)', create: function () { return createStreebog(512); } };
        if (oid === OID.GOST94) return { name: 'GOST R 34.11-94', create: function () { return createGost94('cryptopro'); } };
        return null;
    }
    // Какой хеш положен ключу, если в подписи его явно не назвали.
    function hashOidForKey(keyOid) {
        if (keyOid === OID.KEY_2012_256) return OID.STREEBOG_256;
        if (keyOid === OID.KEY_2012_512) return OID.STREEBOG_512;
        if (keyOid === OID.KEY_2001) return OID.GOST94;
        return null;
    }
    function isGostKey(oid) { return oid === OID.KEY_2012_256 || oid === OID.KEY_2012_512 || oid === OID.KEY_2001; }
    function isGostSignature(oid) {
        return oid === OID.SIG_2012_256 || oid === OID.SIG_2012_512 || oid === OID.SIG_2001 || isGostKey(oid);
    }

    /* ══════════════ ГОСТ Р 34.10: проверка подписи ══════════════ */

    var ZERO = BigInt(0), ONE = BigInt(1), TWO = BigInt(2), THREE = BigInt(3), FOUR = BigInt(4), EIGHT = BigInt(8);

    function big(hex) { return BigInt('0x' + hex); }
    var CURVES = {};
    function curve(oid) {
        var key = CURVE_ALIAS[oid] || oid;
        if (!CURVE_HEX[key]) return null;
        if (!CURVES[key]) {
            var c = CURVE_HEX[key];
            CURVES[key] = { oid: key, p: big(c.p), a: big(c.a), b: big(c.b), q: big(c.q), x: big(c.x), y: big(c.y) };
        }
        return CURVES[key];
    }

    function mod(a, m) { var r = a % m; return r < ZERO ? r + m : r; }
    function modInv(a, m) {
        var t = ZERO, newT = ONE, r = m, newR = mod(a, m);
        while (newR !== ZERO) {
            var q = r / newR, tmp = t - q * newT;
            t = newT; newT = tmp;
            tmp = r - q * newR; r = newR; newR = tmp;
        }
        if (r !== ONE) throw new Error('NOT_INVERTIBLE');
        return mod(t, m);
    }

    /* Якобиевы координаты (X, Y, Z): x = X/Z², y = Y/Z³. Бесконечность — Z = 0. */
    function jDouble(P, c) {
        if (P.z === ZERO || P.y === ZERO) return { x: ONE, y: ONE, z: ZERO };
        var p = c.p;
        var yy = mod(P.y * P.y, p), s = mod(FOUR * P.x * yy, p);
        var zz = mod(P.z * P.z, p);
        var m = mod(THREE * P.x * P.x + c.a * zz * zz, p);
        var x3 = mod(m * m - TWO * s, p);
        var y3 = mod(m * (s - x3) - EIGHT * yy * yy, p);
        var z3 = mod(TWO * P.y * P.z, p);
        return { x: x3, y: y3, z: z3 };
    }
    function jAdd(P, Q, c) {
        if (P.z === ZERO) return Q;
        if (Q.z === ZERO) return P;
        var p = c.p;
        var z1z1 = mod(P.z * P.z, p), z2z2 = mod(Q.z * Q.z, p);
        var u1 = mod(P.x * z2z2, p), u2 = mod(Q.x * z1z1, p);
        var s1 = mod(P.y * Q.z * z2z2, p), s2 = mod(Q.y * P.z * z1z1, p);
        if (u1 === u2) {
            if (s1 !== s2) return { x: ONE, y: ONE, z: ZERO };
            return jDouble(P, c);
        }
        var h = mod(u2 - u1, p), r = mod(s2 - s1, p);
        var hh = mod(h * h, p), hhh = mod(h * hh, p), v = mod(u1 * hh, p);
        var x3 = mod(r * r - hhh - TWO * v, p);
        var y3 = mod(r * (v - x3) - s1 * hhh, p);
        var z3 = mod(h * P.z * Q.z, p);
        return { x: x3, y: y3, z: z3 };
    }
    function toAffine(P, c) {
        if (P.z === ZERO) return null;
        var zi = modInv(P.z, c.p), zi2 = mod(zi * zi, c.p);
        return { x: mod(P.x * zi2, c.p), y: mod(P.y * zi2 * zi, c.p) };
    }
    // u·P + v·Q одним проходом (трюк Шамира).
    function doubleMul(u, P, v, Q, c) {
        var PQ = jAdd(P, Q, c), R = { x: ONE, y: ONE, z: ZERO };
        var bits = Math.max(u.toString(2).length, v.toString(2).length);
        for (var i = bits - 1; i >= 0; i--) {
            R = jDouble(R, c);
            var bu = (u >> BigInt(i)) & ONE, bv = (v >> BigInt(i)) & ONE;
            if (bu === ONE && bv === ONE) R = jAdd(R, PQ, c);
            else if (bu === ONE) R = jAdd(R, P, c);
            else if (bv === ONE) R = jAdd(R, Q, c);
        }
        return R;
    }
    function onCurve(x, y, c) {
        return mod(y * y - (x * x * x + c.a * x + c.b), c.p) === ZERO;
    }

    function beToBig(b) { return b.length ? BigInt('0x' + bytesToHex(b)) : ZERO; }
    function leToBig(b) {
        var r = new Uint8Array(b.length);
        for (var i = 0; i < b.length; i++) r[i] = b[b.length - 1 - i];
        return beToBig(r);
    }

    /**
     * Открытый ключ ГОСТ из SubjectPublicKeyInfo (DER).
     * → { keyOid, paramSet, digestParamSet, bits, x, y } либо бросает.
     * Нужен PKI.Asn1 (или передайте его вторым аргументом в Node).
     */
    function publicKeyFromSpki(spki, Asn1) {
        Asn1 = Asn1 || (root && root.PKI && root.PKI.Asn1);
        if (!Asn1) throw new Error('ASN1_MISSING');
        var node = Asn1.parse(u8(spki));
        var alg = node.children && node.children[0];
        var bitStr = node.children && node.children[1];
        if (!alg || !bitStr || bitStr.tag !== 0x03) throw new Error('GOST_SPKI');
        var keyOid = alg.children[0].oid;
        if (!isGostKey(keyOid)) throw new Error('NOT_GOST_KEY:' + keyOid);
        var params = alg.children[1];
        var paramSet = params && params.children && params.children[0] ? params.children[0].oid : null;
        var digestParamSet = params && params.children && params.children[1] ? params.children[1].oid : null;
        var inner = Asn1.parse(bitStr.bits);   // OCTET STRING x‖y
        var raw = inner.bytes;
        var half = raw.length >> 1;
        return {
            keyOid: keyOid,
            paramSet: paramSet,
            digestParamSet: digestParamSet,
            bits: keyOid === OID.KEY_2012_512 ? 512 : 256,
            x: leToBig(raw.subarray(0, half)),
            y: leToBig(raw.subarray(half))
        };
    }

    /**
     * Проверка подписи ГОСТ Р 34.10-2012/2001.
     *   digest    — хеш подписанных данных (байты «в памяти», как их отдаёт хеш)
     *   signature — s‖r, big-endian (как лежит в CMS и в сертификате)
     *   key       — результат publicKeyFromSpki()
     * → { valid: true|false } или { valid: null, reason } когда проверить нельзя
     *   (неизвестный набор параметров — это «не умеем», а не «подделка»).
     */
    function verify(digest, signature, key) {
        var c = curve(key.paramSet);
        if (!c) return { valid: null, reason: 'UNKNOWN_PARAMSET:' + key.paramSet };
        var sig = u8(signature);
        var half = sig.length >> 1;
        if (!half || sig.length % 2) return { valid: false, reason: 'BAD_SIGNATURE_LENGTH' };
        var s = beToBig(sig.subarray(0, half)), r = beToBig(sig.subarray(half));
        if (r <= ZERO || r >= c.q || s <= ZERO || s >= c.q) return { valid: false, reason: 'SIGNATURE_OUT_OF_RANGE' };
        if (!onCurve(key.x, key.y, c)) return { valid: false, reason: 'KEY_NOT_ON_CURVE' };
        var e = mod(leToBig(u8(digest)), c.q);
        if (e === ZERO) e = ONE;
        var v = modInv(e, c.q);
        var z1 = mod(s * v, c.q), z2 = mod(c.q - mod(r * v, c.q), c.q);
        var C = toAffine(doubleMul(z1, { x: c.x, y: c.y, z: ONE }, z2, { x: key.x, y: key.y, z: ONE }, c), c);
        if (!C) return { valid: false, reason: 'POINT_AT_INFINITY' };
        return { valid: mod(C.x, c.q) === r };
    }

    var API = {
        OID: OID,
        createStreebog: createStreebog,
        streebog256: streebog256,
        streebog512: streebog512,
        createGost94: createGost94,
        gost94: gost94,
        hashForOid: hashForOid,
        hashOidForKey: hashOidForKey,
        isGostKey: isGostKey,
        isGostSignature: isGostSignature,
        publicKeyFromSpki: publicKeyFromSpki,
        verify: verify,
        curve: curve,
        _hex: { toHex: bytesToHex, fromHex: hexToBytes }
    };
    if (typeof module !== 'undefined' && module.exports) module.exports = API;
    if (root) { root.PKI = root.PKI || {}; root.PKI.Gost = API; }
})(typeof window !== 'undefined' ? window : (typeof globalThis !== 'undefined' ? globalThis : null));
